<template>
    <div class="w-100 text-left">
        <div v-if="!walletConnected">
        </div>
        <div v-else class="col m-auto">
            <!--      {{ stakeAccounts.length }} stake accounts found.-->

            <div class="row" v-if="!hideCharts">
                <div class="col-sm-8">
                    <div class="card">
                        <div class="card-body">
                            <!--              <el-select v-model="selectedCurrency" class="ml-auto" @change="getFxRates">
                                            <el-option v-for="c in currencyList" :value="c" :label="c" :key="c"></el-option>
                                          </el-select>-->
                            <div class="row">
                                <div class="col">
                                    <h3 class="text-muted">Stake Account Rewards Over Time</h3>
                                </div>
                                <div class="col-3 text-right">
                                    <el-link type="primary"
                                             @click="showReport = !showReport; clicky('/dashboard/showreport/')"
                                             class="lead text-primary"
                                             title="Get CSV reports and exports in your own currency to help you file your own tax reports"
                                    >
                                        Tax Exports &nbsp; <i style='font-size:150%' class="fas fa-file-csv ml-1"></i>
                                    </el-link>
                                </div>
                            </div>
                            <area-chart :data="totalReturnsChart" :min="chartMin"></area-chart>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4" v-if="latestEpoch">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="text-muted">Portfolio Distribution</h4>
                            <pie-chart
                                :data="[['Staked', (latestEpoch.postBalance / 1e9)], ['Unstaked',balances['So11111111111111111111111111111111111111112'] || 0], ['Liquid',liquidStaked]]"
                                :donut="true"
                                :library="{ cutout: 95 }"
                            ></pie-chart>
                            <div class="text-center" style="margin-top:-160px;margin-bottom: 104px">
                                <p class="display-5 mb-0">{{
                                        ((((latestEpoch.postBalance || 0) / 1e9) + liquidStaked) / (((latestEpoch.postBalance || 0) / 1e9) + liquidStaked + (balances['So11111111111111111111111111111111111111112'] || 0)) * 100).toFixed(1)
                                    }}%</p>
                                <div class="text-muted ">Staked</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row card-deck" v-if="!hideCharts">
                <!--        <div class="col">-->
                <div class="card">
                    <div class="card-body">
                        <h4 class="text-muted">Unstaked SOL</h4>
                        <h2>{{ (balances['So11111111111111111111111111111111111111112'] || 0).toFixed(4) }} SOL</h2>
                    </div>
                </div>
                <!--        </div>-->
                <!--        <div class="col">-->
                <div class="card">
                    <div class="card-body">
                        <h4 class="text-muted">Staked SOL</h4>
                        <h2 v-if="latestEpoch">{{ (latestEpoch.postBalance / 1e9).toFixed(4) }} SOL</h2>
                    </div>
                </div>
                <!--        </div>-->
                <!--        <div class="col">-->
                <div class="card">
                    <div class="card-body">
                        <h4 class="text-muted">Liquid Staked</h4>
                        <h2>{{ (liquidStaked).toFixed(4) }} SOL</h2>
                    </div>
                </div>
                <!--        </div>-->
                <!--        <div class="col">-->
                <div class="card">
                    <div class="card-body">
                        <h4 class="text-muted">Average Staked Returns</h4>
                        <h2>{{ (avgReturns * 100).toFixed(2) }}%</h2>
                    </div>
                </div>
                <!--        </div>-->

            </div>

            <div class="card my-5" v-if="!hideCharts">
                <el-popover title="Staking Epochs" style="max-width:250px" width="350px">

                    <p>Staking rewards on Solana are paid once every <strong>epoch</strong>.</p>
                    <p>An epoch occurs roughly every 3 days, but the duration changes based on network performance.</p>
                    <p>Staking and unstaking occurs at the start of each new epoch.
                        This means if you stake or unstake near the end of an epoch your funds will be earning rewards -
                        or ready to withdraw - within minutes to hours. But if you act at the start of an epoch, you may
                        need to wait as much as 3 days for the action to complete.</p>

                    <template #reference>
                        <div class="card-header">
                            <h3 class="card-title">Epoch Progress</h3>
                            <div class="w-75 m-auto p-3">

                                <el-progress
                                    :percentage="(parseFloat(dashboardEpoch.epochProgress || 0) *100).toFixed(0)"
                                    type="line"
                                    :text-inside="false"
                                    style="max-height: 56px"
                                    width="500"
                                />
                            </div>
                            <div class="card-options">
                                {{ timeLeftInEpoch }} remaining
                            </div>
                        </div>
                    </template>

                </el-popover>

            </div>


            <div class="card my-5" v-if="!hideCharts || stakeAccounts.length">
                <div class="card-header"><h3 class="card-title"> Stake Accounts </h3>
                    <div class="card-options">
                        <el-button color="#626aef" size="large"
                                   @click="activeStakeAccount=null; showDelegate=true;delegationAmount=balance - 0.05; clicky('/dashboard/newstake/')">
                            New Stake
                        </el-button>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="text-center my-5 display-5" v-if="loadingAccounts">
                        Loading Stake Accounts...
                    </div>
                    <div v-else>
                        <div class="text-center my-5" v-if="stakeAccounts.length === 0">
                            <div class="display-5">
                                No stake accounts found - why not
                                <el-link
                                    @click="activeStakeAccount=null; showDelegate=true; clicky('/dashboard/newstake/')"
                                    class="text-blue display-5 border-bottom">
                                    create one
                                </el-link>
                                now?
                            </div>
                        </div>
                        <table class="table table-hover card-table table-vcenter text-nowrap"
                               v-if="stakeAccounts.length">
                            <thead>
                            <th>Validator</th>
                            <!--              <th title="The actual rewards you have earned on this account since initial delegation">Effective APY</th>-->
                            <th title="Our current score for this validator">Health</th>
                            <th>Stake</th>
                            <th>Actions</th>
                            </thead>
                            <tbody>
                            <tr v-for="(account,index) in stakeAccounts.sort( (a,b) => { return getStakeAccountBalanceSol(a) < getStakeAccountBalanceSol(b); })">
                                <td v-if="validatorData[account.account.data.parsed?.info?.stake?.delegation?.voter]">
                                    <div class="row">
                                        <div style="width:65px">
                                            <img
                                                :src="validatorData[account.account.data.parsed?.info?.stake?.delegation?.voter]?.avatar_url || ''"
                                                width="60" class="brround"
                                                v-if="validatorData[account.account.data.parsed?.info?.stake?.delegation?.voter]">
                                        </div>
                                        <div class="col my-auto">
                                            {{
                                                validatorData[account.account.data.parsed?.info?.stake?.delegation?.voter]?.name || 'Unknown'
                                            }}<br>
                                            <a class="small text-muted" target="_blank"
                                               :href="'https://solana.fm/address/'+account.pubkey.toString()">{{ account.pubkey.toString() }}</a>


                                        </div>
                                    </div>

                                </td>
                                <td v-else>
                                    <div class="row">

                                        <div style="width:65px;height:60px;">
                                        </div>
                                        <div class="col my-5">
                                            {{
                                                account.account.data.parsed?.info?.stake?.delegation?.voter || 'Undelegated Stake Account'
                                            }}<br>
                                            <a class="small text-muted" target="_blank"
                                               :href="'https://solana.fm/address/'+account.pubkey.toString()">{{ account.pubkey.toString() }}</a>


                                        </div>
                                    </div>
                                </td>

                                <!--                <td>
                                                  <span v-if="account.account.data.parsed.info.stake">
                                                    {{ getStakeAPY(account) }}%
                                                  </span>
                                                  <span v-else>
                                                    0.00%
                                                  </span>

                                                </td>-->
                                <td>
                                    <stake-health :account="account"
                                                  :validator="validatorData[account.account.data.parsed?.info?.stake?.delegation?.voter] || {}"
                                                  :epoch-info="epochInfo"></stake-health>
                                </td>
                                <td>
                                    {{ getStakeAccountBalanceSol(account) }} SOL
                                </td>
                                <td>
                                    <div class="dropdown">
                                        <!-- todo: swap for a vue ui component -->
                                        <el-dropdown>
                                            <el-button type="primary">
                                                Actions
                                                <el-icon class="el-icon--right">
                                                    <arrow-down/>
                                                </el-icon>
                                            </el-button>
                                            <template #dropdown>
                                                <el-dropdown-menu>
                                                    <a class="dropdown-item" href="#"
                                                       @click="delegationAmount = (account.account?.lamports || 0) /1e9;
                         activeStakeAccount = account ;showDelegate = true; clicky('/dashboard/delegateaccount/')"
                                                       v-if="(!account.account.data?.parsed?.info?.stake || (account.account?.data?.parsed?.info?.stake?.delegation?.deactivationEpoch < this.epochInfo.epoch))"
                                                       :disabled="account.account.data.parsed.info.stake">Delegate To
                                                        Validator</a>
                                                    <a class="dropdown-item" href="#"
                                                       @click="delegationAmount = (account.account?.lamports || 0) /1e9; activeStakeAccount = account; this.validatorToDelegate = this.validatorData[account.account?.data?.parsed?.info?.stake?.delegation?.voter]; delegateStake()"
                                                       v-if="account.account?.data?.parsed?.info?.stake?.delegation?.deactivationEpoch == this.epochInfo.epoch">Cancel
                                                        Deactivation</a>
                                                    <a class="dropdown-item" href="#"
                                                       @click="withdrawStake(account); clicky('/dashboard/showwithdraw/')"
                                                       title="Before withdrawing your stake you must first deactivate it"
                                                       v-if="canWithdraw(account)"
                                                       :disabled="account.account.data.parsed.info.stake"
                                                       v-html="'Withdraw '+ canWithdraw(account)/1e9 + ' SOL'"></a>
                                                    <a class="dropdown-item" href="#"
                                                       @click="activeStakeAccount = account; withdrawAmount=100; updateWithdrawalAmountSol(); showDeactivate = true; clicky('/dashboard/showdeactivate/')"
                                                       title="Deactivate your stake in order to withdraw it when the epoch ends"
                                                       v-if="(account.account.data?.parsed?.info?.stake  &&
                           ((!account.account?.data?.parsed?.info?.stake?.delegation?.deactivationEpoch) || (account.account?.data?.parsed?.info?.stake?.delegation?.deactivationEpoch > 1e8) ))"
                                                       :disabled="!account.account.data.parsed.info.stake">Unstake
                                                        (Deactivate)</a>
                                                    <el-divider></el-divider>
                                                    <a class="dropdown-item"
                                                       href="#"
                                                       @click="activeStakeAccount = account;
                           showSplit=true;clicky('/dashboard/showsplit/')">Split Stake Account</a>
                                                    <a class="dropdown-item" href="#"
                                                       v-if="canMerge(account).length > 1"
                                                       @click="accountsToMerge = []; activeStakeAccount = account;
                           showMerge=true; clicky('/dashboard/showmerge/')">Merge Stake Account(s)</a>
                                                </el-dropdown-menu>
                                            </template>
                                        </el-dropdown>

                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

            <div class="card" v-if="!hideLSTs">
                <div class="card-header"><h3 class="card-title"> Liquid Staking </h3>
                    <!--          <div class="card-options"><a href="javascript:void(0);" class="btn btn-sm btn-primary">Create New</a></div>-->
                </div>
                <div class="card-body p-0">
                    <table class="table table-hover card-table table-vcenter text-nowrap">
                        <thead>
                        <tr>
                            <th>Pool</th>
                            <th>APY</th>
                            <th>Balance</th>
                            <th>SOL Value</th>
                        </tr>
                        </thead>
                        <tr v-for="( mint) in Object.keys(balances).filter((mint) => { return stakePoolMints.includes(mint) }).sort((a,b) => {
                  return balances[a] < balances[b]
                })">
                            <td><img :src="getToken(mint).logoURI" width="60" class="brround">
                                {{ stakePools.items[mint].name }}
                            </td>
                            <td>{{ (stakePools.items[mint].apy.apy * 100).toFixed(2) }}%</td>
                            <td>{{ balances[mint].toFixed(8) }} {{ getToken(mint).symbol }}</td>
                            <td>{{
                                    (balances[mint] * (stakePools.items[mint].totalLamports / stakePools.items[mint].poolTokenSupply)).toFixed(8)
                                }} SOL
                            </td>

                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <el-dialog v-model="showDelegate" title="Stake Solana">
            <el-form size="large" label-width="auto">
                <el-form-item label="How much to delegate?">
                    <el-slider v-model=withdrawAmount
                               :marks="{
                            1:'1%',
                            25:'25%',
                            50:'50%',
                            75:'75%',
                            100:'100%'
                          }"
                               @input="delegationAmount = (balance * withdrawAmount/100) - 0.05"
                               :disabled="activeStakeAccount"></el-slider>
                </el-form-item>
                <el-form-item label="Amount in SOL">
                    <el-input-number v-model="delegationAmount"
                                     :disabled="activeStakeAccount" :max="balance - 0.05" :min="0.05"
                                     :controls="false"></el-input-number>

                </el-form-item>
                <el-form-item label="Validator">
                    <el-autocomplete
                        v-model="validatorToDelegateName"
                        :fetch-suggestions="searchValidators"
                        @select="selectValidator"
                        clearable
                        :trigger-on-focus="false"
                        popper-class="my-autocomplete"
                        class="w-100">
                        <template #suffix>
                            <el-icon class="el-input__icon">
                                <Search/>
                            </el-icon>
                        </template>
                        <template #default="{ item }">
                            <div class="row">
                                <div class="col-10">
                                    {{ item.name }}
                                </div>
                                <!--                  <div class="col-4 font-weight-semibold">
                                                    {{item.commission}}%
                                                  </div>-->
                            </div>

                        </template>
                    </el-autocomplete>
                </el-form-item>
            </el-form>
            <p v-if="!activeStakeAccount">Enter the amount of SOL you wish to stake, then choose the validator you wish
                to delegate to.</p>
            <p v-else>Choose the validator to delegate this stake account to and confirm to begin staking.</p>
            <el-button type="primary" @click="delegateStake(); showDelegate = false;"
            >Confirm
            </el-button
            >
        </el-dialog>
        <el-dialog v-model="showDeactivate" title="Unstake (Deactivate) Solana">
            <el-form class="p-3" size="large" label-width="auto">
                <el-form-item label="How much to deactivate?">
                    <el-slider v-model=withdrawAmount
                               :marks="{
                            1:'1%',
                            25:'25%',
                            50:'50%',
                            75:'75%',
                            100:'100%'
                          }"
                               @input="updateWithdrawalAmountSol"></el-slider>

                </el-form-item>
                <el-form-item label="Amount In SOL">
                    <el-input-number v-model="withdrawAmountSol" @input="updateWithdrawAmount" min=0
                                     :max="getStakeAccountBalanceSol(activeStakeAccount)"
                                     :controls="false"></el-input-number>
                </el-form-item>
            </el-form>
            <p class="">Before withdrawing you must first deactivate your stake account, then wait for the end of the
                epoch (estimated in {{ timeLeftInEpoch }}) before withdrawing.</p>
            <p class="">If you wish to perform a partial withdrawal simply enter the amount or percentage you wish to
                withdraw, and we will automatically split your stake account and deactivate the portion for withdrawal,
                leaving
                the rest staked</p>
            <a class="btn btn-success" href="#" @click="deactivateStake">Withdraw SOL</a>
        </el-dialog>

        <el-dialog v-model="showSplit" title="Split stake account">
            <el-form size="large" label-width="auto">
                <el-form-item label="Current Account Balance">{{
                        getStakeAccountBalanceSol(activeStakeAccount)
                    }}
                </el-form-item>
                <el-form-item label="New Account Balance">
                    <el-input-number :max="getStakeAccountBalanceSol(activeStakeAccount)"
                                     v-model="splitStakeAmount" :min=0 :controls="false"></el-input-number>
                </el-form-item>
                <el-form-item label="Remaining In Account">
                    {{ getStakeAccountBalanceSol(activeStakeAccount) - splitStakeAmount }}
                </el-form-item>
            </el-form>
            <p class="">Splitting a stake account will allow you to separate stake into a new account. If the original
                account is already delegated to a validator then the new account will be delegated, too.</p>
            <el-button type="success" @click="splitStake">Split Stake</el-button>
        </el-dialog>

        <el-dialog model-value="showMerge" v-model="showMerge" title="Merge Stake Accounts">
            <el-checkbox-group v-model="accountsToMerge">
                <el-table :data="canMerge(activeStakeAccount)" ref="mergeTable">
                    <el-table-column width="30">
                        <template #default="scope">
                            <el-checkbox :label="scope.row" :key="scope.row" class="w-100"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column property="pubkey" label="Account"></el-table-column>
                    <el-table-column class="text-right" label="Balance" align="right">
                        <template #default="scope">
                            {{ getStakeAccountBalanceSol(scope.row) }}
                        </template>
                    </el-table-column>
                </el-table>
            </el-checkbox-group>
            <p class="lead">Merge your accounts together to simplify your accounts.</p>
            <el-button type="success" @click="mergeStake(accountsToMerge); showMerge=false">Merge Accounts</el-button>
        </el-dialog>

        <el-dialog v-model="showReport" title="Staking Rewards" width="80%">

            <div class="row mb-2">
                <div class="col"></div>
                <div class="col text-right">
                    Currency:
                    <el-select v-model="selectedCurrency" class="ml-auto" @change="getFxRates">
                        <el-option v-for="c in currencyList" :value="c" :label="c" :key="c"></el-option>
                    </el-select>
                    <el-button @click="downloadCSVData" type="primary">Export CSV</el-button>
                </div>
            </div>
            <el-table :data="fiatReturns"
                      :default-sort="{ prop: 'epoch', order: 'descending' }"
            >
                <el-table-column prop="date" label="Date" sortable ></el-table-column>
                <el-table-column prop="epoch" label="Epoch" sortable ></el-table-column>
                <el-table-column prop="balance" label="Balance (SOL)">
                    <template #default="scope">
                        {{ (scope.row.balance).toFixed(9) }}
                    </template>
                </el-table-column>
                <el-table-column prop="fiatBalance" :label="'Balance (' + selectedCurrency + ')'">
                    <template #default="scope">
                        {{ fiatFormatter.format(scope.row.fiatBalance) }}
                    </template>
                </el-table-column>
                <el-table-column prop="rewards" label="Rewards (SOL)" sortable >
                    <template #default="scope">
                        {{ (scope.row.rewards).toFixed(9) }}
                    </template>
                </el-table-column>
                <el-table-column prop="fiatRewards" :label="'Rewards (' + selectedCurrency + ')'">
                    <template #default="scope">
                        {{ fiatFormatter.format(scope.row.fiatRewards) }}
                    </template>
                </el-table-column>
                <el-table-column prop="returns" label="Staking APY">
                    <template #default="scope">
                        <span :title="scope.row.epochsPerYear">{{
                            (scope.row.epochApy * 100).toFixed(2)
                            }}%
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="mevRewards" label="MEV Tips (SOL)" sortable>
                    <template #default="scope">
                        {{ (scope.row.mevRewards).toFixed(9) }}
                    </template>
                </el-table-column>
                <el-table-column prop="fiatMevRewards" :label="'MEV Tips (' + selectedCurrency + ')'" sortable >
                    <template #default="scope">
                        {{ fiatFormatter.format(scope.row.fiatMevRewards) }}
                    </template>
                </el-table-column>
                <el-table-column prop="mevReturns" label="Additional MEV APY">
                    <template #default="scope">
                        +<span :title="scope.row.epochsPerYear">{{
                            (scope.row.mevApy * 100).toFixed(2)
                            }}%
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>


    </div>
</template>

<script>
import axios from "axios";
import collect from 'collect.js'

import {watchEffect, reactive, ref, unref, isProxy, toRaw} from "vue";
import {$vfm, VueFinalModal, ModalsContainer} from 'vue-final-modal'
import {useWallet} from 'solana-wallets-vue';
import {
    Authorized,
    Connection,
    Keypair,
    Lockup,
    PublicKey,
    sendAndConfirmTransaction,
    StakeProgram,
    Transaction
} from "@solana/web3.js";
import TokenSelector from "./TokenSelector";
import StakeHealth from "./StakeHealth"
// import {TOKEN_LIST_URL} from "@jup-ag/core";

import StakeAccount from "./StakeAccount";
// import getDashboardEpochInfo from '@/utils/epoch.ts'

import {ArrowDown, Search} from '@element-plus/icons-vue'
import {ElMessage, ElMessageBox} from 'element-plus'

import JsonCSV from 'vue-json-csv'

const localhost = false;
// console.log(getDashboardEpochInfo())
// let endpoint =
// const connection = new Connection('https://ssc-dao.genesysgo.net/', {
// const connection = new Connection('http://localhost:8899/', {
// const connection = new Connection('https://api.devnet.solana.com', {

const connection = new Connection('https://specific-lanny-fast-mainnet.helius-rpc.com/', {
    commitment: 'confirmed',
    confirmTransactionInitialTimeout: 12000
});
// const connection = new Connection("https://solana-mainnet.rpc.extrnode.com", "confirmed");
// const lightcon = new Connection("https://solana-mainnet.rpc.extrnode.com", "confirmed");
let lightcon = new Connection('https://specific-lanny-fast-mainnet.helius-rpc.com/')

// Helius securerpc limited to 5 RPS per IP, so lets setup a bottleneck
import Bottleneck from "bottleneck";

const limiter = new Bottleneck({
    maxConcurrent: 4,
    minTime: 250
});



export default {
    name: "StakeDashboard",
    components: {
        StakeAccount,
        StakeHealth,
        VueFinalModal,
        ArrowDown,
        Search,
        JsonCSV
    },
    props: [
        'hideCharts',
        'hideLSTs'
    ],
    data() {
        return {
            loadingAccounts: true,
            stakeAccounts: [],
            stakePoolMints: [
                "CYvAfji7ms2TJQiuXsT5pEUfQkc9DxjPrUox9zEWY1KC",
                "95iVJaoCbuBFGpMYZULhiNPdRKMBKki3SsLZ7UtkbsR",
                "AJZU5dcBo1Kc7x7Qm2bV4aokSRP99qjoTy6hc6Q5icFk",
                "7Q2afV64in6N6SeZsAAB81TJzwDoD6zpqmHkzi9Dcavn",
                "C4kq9QRFLAqwYHK7p4Ez54KMZLZNw2yLsiT3KN4FSmdH",
                "2cWVRi4171yduSmAsNeSScw2u8WyrtAmjerjprWDCvxb",
                "4qSYmkNaukFsMRWWxfwa3F1DtCwVNfmHgEfgx5b7zjYS",
                "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
                "5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm",
                "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
                "GEJpt3Wjmr628FqXxTgxMce1pLntcPV4uFi8ksxMyPQh",
                "RUNx21P7pv9XgYdq6CXteDCjk8by2TGyvgDHoqRqi4s",
                "9AHPS2GF4nWfN2UssYzD48ZTQycftB2JZzo2qZQ2fm7S",
                "6kWimEvkh79fJugE7g4fGbopV37rT6XsWxA7mHzWeCZ7",
                "dfSopoggNzbJJ91JDUS5Yg6Za7Wq3vL11BUvbraXWJU",
                "FCug8UqfpzT2ZWGS7TpT42rFFxiwFCx5hYSuezvCBHk4",
                "eSoLV1T3oS9kPdNuCdCDSSWnKPCpnn3CgqRx2zzoidy",
                "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
                "Hg35Vd8K3BS2pLB3xwC2WqQV8pmpCm3oNRGYP1PEpmCM",
            ],
            tokens: [],
            stakePools: {},
            balances: [],
            epochInfo: [],
            epochs: [],
            epochsPerYear: 170,
            dashboardEpoch: {},
            selectedCurrency: 'USD',
            currencyList: ['USD', 'GBP', 'EUR', 'CAD', 'JPY', 'AUD', 'SGD'],
            fxRates: [],
            validatorData: {},
            validatorToDelegate: {},
            validatorToDelegateName: {},
            accountsToMerge: [],
            // modal data fields
            delegationAmount: 0,
            activeStakeAccount: null,
            withdrawAmount: 100,
            withdrawAmountSol: 0,
            splitStakeAmount: 0,
            showDelegate: false,
            showDeactivate: false,
            showSplit: false,
            showMerge: false,
            showReport: false,
            scores: {},
        }
    },
    async mounted() {
        // window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        if (typeof this.from !== 'undefined') {
            this.fromAddress = this.from
        }
        if (typeof this.to !== 'undefined') {
            this.toAddress = this.to
        }
        this.dashboardEpoch = await this.getDashboardEpochInfo()
        this.epochInfo = await connection.getEpochInfo()
        this.getTokens()
        // this.getScores()
        console.log('mountd with wallet', this.wallet, 'connected', this.wallet.connected)
        this.getWalletBalances()
        this.getFxRates()

        this.getStakeAccounts()
        let gotVals = this.getValidators()

        window.setInterval(() => {
            this.getWalletBalances()
        }, 15000)

        let hash = window.location.hash.split('/')
        console.log('got hash', hash)
        if (hash[0] == '#delegate') {
            // ensure we've loaded the validator list so we can show delegation info
            let loading = ElMessageBox.alert('Preparing to delegate to ' + hash[1], 'Loading validator info', {
                type: 'info',
                showClose: false,
                "show-confirm-button": false,
                "close-on-has-change": true
            })
            console.log('awaiting validator list for delegation')
            await gotVals
            window.location.hash = '#delegating/' + hash[1]
            console.log('got list, lets delegate')
            this.validatorToDelegate = this.validatorData[hash[1]]
            this.validatorToDelegateName = this.validatorToDelegate.name
            this.showDelegate = true

        }


    },
    computed: {
        timeLeftInEpoch() {
            let now = new Date();
            let end = this.dashboardEpoch.epochTimeRemaining || 0
            let then = new Date(now.getTime() + end)
            let diff = new Date(then - now)
            let days = diff.getUTCDate() - 1;
            let hours = diff.getUTCHours();
            let mins = diff.getUTCMinutes();
            let response = ''
            if (days > 0) response += days + 'd '
            response += hours + 'h ' + mins + 'm'
            console.log('time left', response)
            return response

        },
        wallet() {
            return reactive(useWallet())
        },
        walletAddress() {
            return this.wallet.address
        },
        walletConnected() {
            return this.wallet.connected
        },
        totalReturns() {
            const totalReturns = {}
            let epoch = 0
            while (epoch < this.epochInfo.epoch) {
                let activeStake = 0
                let rewards = 0
                let returns = 0
                let mevrewards = 0
                let accounts = 0
                this.stakeAccounts.forEach((a) => {
                    if (typeof a.rewards[epoch] !== 'undefined') {
                        if (a.rewards[epoch] !== null) {
                            activeStake = activeStake + a.rewards[epoch].postBalance
                            rewards = rewards + a.rewards[epoch].amount
                            mevrewards = mevrewards + ( a.mevRewards[epoch] || 0 )

                            accounts++
                        }
                    }
                })
                // before we've loaded all epochs we assume a 48 hr epoch as toly intended
                let epochDuration = (this.epochs[epoch]?.duration || 24*60*60*2) * 1000
                let epochsPerYear = (1000 * 60 * 60 * 24 * 365) / epochDuration
                totalReturns[epoch] = {
                    epoch: epoch,
                    amount: rewards,
                    mevAmount: mevrewards,
                    postBalance: activeStake,
                    accounts: accounts,
                    returns: (1 + rewards / (activeStake - rewards)) ** epochsPerYear - 1
                }
                epoch++
            }
            return collect(totalReturns).where('accounts', '>', 0)
        },
        fiatReturns() {
            const fiatReturns = []
            this.totalReturns.sortByDesc('epoch').items.forEach((e) => {
                let epoch = e.epoch
                let epochStart = this.epochs[epoch].start
                let epochEnd = this.epochs[epoch].end
                let fxRate = this.fxRates[epochStart]
                let epochDuration = this.epochs[epoch].duration * 1000
                let epochsPerYear = (1000 * 60 * 60 * 24 * 365) / epochDuration

                fiatReturns.push({
                    epoch: e.epoch,
                    date: epochStart,
                    fxRate: fxRate,
                    balance: e.postBalance / 1e9,
                    fiatBalance: e.postBalance * fxRate / 1e9,
                    rewards: e.amount / 1e9,
                    fiatRewards: e.amount * fxRate / 1e9,
                    epochsPerYear: epochsPerYear,
                    epochApy: (1 + e.amount / (e.postBalance - e.amount)) ** epochsPerYear - 1,
                    mevRewards: e.mevAmount / 1e9,
                    fiatMevRewards: e.mevAmount * fxRate / 1e9,
                    mevApy: (1 + e.mevAmount / (e.postBalance - e.mevAmount)) ** epochsPerYear - 1,

                })
            })
            console.log(fiatReturns)
            return fiatReturns
        },
        fiatFormatter() {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: this.selectedCurrency
            })
        },
        totalReturnsChart() {
            let chartData = {}
            this.totalReturns.map((r) => {
                chartData[r.epoch] = r.postBalance / 1e9
            })
            return chartData
        },
        chartMin() {
            return Math.floor(this.totalReturns.min('postBalance') / 1e9)
        },
        latestEpoch() {
            return this.totalReturns.last() || {postBalance: 0}
        },
        liquidStaked() {
            let total = 0
            if (!this.stakePools) return 0
            this.stakePoolMints.forEach((m) => {
                // console.log(m)
                if (this.balances[m]) {
                    let pool = this.stakePools?.items[m] || null
                    if (pool !== null) total = total + (this.balances[m] * (pool.totalLamports / pool.poolTokenSupply)) // we need to know the pool mint ratio!
                    // console.log(total)
                }
            })
            return total
        },
        avgReturns() {
            return this.totalReturns.avg('returns')
        }

    },
    watch: {

        walletConnected(now, prev) {
            console.log('wallet changed')
            let hero = document.getElementById('staking-hero');
            if (this.wallet.connected) {
                this.getWalletBalances()
                this.getStakeAccounts()
                this.clicky('/dashboard/wallet-connected')
                if (hero !== null) hero.style.display = "none"
            } else {
                this.balances = {}
                this.balance = 0
                this.clicky('/dashboard/wallet-disconnected')
                if (hero !== null) hero.style.display = "block"

            }

        },
    },
    methods: {
        log(x) {
            console.log(x)
        },
        getScores() {
            console.log('getting scores')
            axios.get('/validators/scores').then((response) => {
                this.scores = response.data
                console.log(scores, 'scores')
            })
        },
        async getStakeAccounts() {
            if (!this.walletConnected) {
                return
            }

            // eslint-disable-next-line
            console.log('getting stake accounts')
            let stakeAccountInfo = await connection.getParsedProgramAccounts(
                StakeProgram.programId,
                {
                    filters: [
                        {
                            memcmp: {
                                offset: 44,
                                bytes: this.wallet.publicKey.toString()
                            },
                        },
                        {
                            dataSize: 200
                        }
                    ]
                }
            )

            this.stakeAccounts = stakeAccountInfo
            console.log('retrieved stake accounts', this.stakeAccounts)
            this.getRewards()
            this.getMevRewards()
            this.loadingAccounts = false
        },
        getMevRewards() {
            axios.get('/jito/wallet?pubkey=' + this.wallet.publicKey.toString()).then((response) => {
                // foreach account, set the mev rewards
                let mevRewards = response.data
                console.log('mev rewards',mevRewards)
                this.stakeAccounts = this.stakeAccounts.map((a) => {
                    a.mevRewards = mevRewards[a.pubkey.toString()] || {}
                    console.log(a.mevRewards, 'mev rewards for account')
                    return a
                })
            })
        },
        getStakeAccountBalanceSol(account) {
            let stake = account?.account?.data?.parsed?.info?.stake?.delegation?.stake
            if (!stake) stake = account.account.lamports - account.account.data.parsed.info.meta.rentExemptReserve
            return stake / 1e9
        },
        async getRewards() {
            let firstEpoch = 99999
            let thisEpoch = this.epochInfo.epoch

            this.stakeAccounts = this.stakeAccounts.map((a) => {
                let activationEpoch = a.account.data.parsed.info?.stake?.delegation?.activationEpoch || null
                // console.log(a, activationEpoch)
                if (activationEpoch !== null) {
                    if (activationEpoch < firstEpoch) firstEpoch = activationEpoch
                }
                a.rewards = {}
                return a
            })
            if (localhost) return
            console.log('getting rewards from ' + firstEpoch + ' to ', thisEpoch)
            // get most recent data first
            for (let i = (thisEpoch -1); i > (firstEpoch-1); i--) {
                let accounts = []
                this.stakeAccounts.forEach((a) => {
                    let activationEpoch = a.account.data.parsed.info?.stake?.delegation?.activationEpoch || null
                    if ((activationEpoch !== null) && (activationEpoch <= i)) accounts.push(a.pubkey)
                })

                limiter.schedule(() => this.getInflationReward(accounts, Number(i)))

                /*limiter.schedule(()=> connection.getInflationReward(accounts, Number(i)) ).then((rewards) => {
                    // console.log('received ', rewards, accounts)
                    rewards.forEach((r, index) => {
                        let pubKey = accounts[index]
                        this.stakeAccounts.map((a) => {
                            if (a.pubkey == pubKey) a.rewards[i] = r
                            // else console.log(a.pubkey, ' didnt match ' ,pubKey)
                            return a
                        })
                    }).bind(this)
                    this.$forceUpdate()
                })*/
            }

        },
        async getInflationReward(accounts, epoch) {
            let rewards = await connection.getInflationReward(accounts, epoch)
            rewards.forEach((r, index) => {
                let pubKey = accounts[index]
                console.log(accounts, index, r)
                console.log(pubKey)
                this.stakeAccounts.map((a) => {
                    if (a.pubkey.toBase58() == pubKey.toBase58()) {
                        a.rewards[epoch] = r
                        console.log('reward', r, a)
                    }
                    return a
                })
            })
            return rewards
        },

        clicky: function (url) {
            if (typeof clicky === 'object') {
                // eslint-disable-next-line
                clicky.log(url)
            } else {
                console.debug('Clicky Log:' + url)
            }
        },
        async getDashboardEpochInfo() {
            // Inspired from explorer.solana.com DashboardInfo
            const epochInfo = await connection.getEpochInfo();
            const {slotIndex, slotsInEpoch} = epochInfo;

            const epochProgress = slotIndex / slotsInEpoch;

            const samples = await lightcon.getRecentPerformanceSamples(300);
            console.log('sample', samples)
            // const samples = [{samplePeriodSecs: 550, numSlots: 1000}] // Hardcoded until mystery above is solved
            const timePerSlotSamples = samples
                .filter((sample) => {
                    return sample.numSlots !== 0;
                })
                .slice(0, 60)
                .map((sample) => {
                    return sample.samplePeriodSecs / sample.numSlots;
                })

            const samplesInHour = timePerSlotSamples.length < 60 ? timePerSlotSamples.length : 60;
            const avgSlotTime_1h =
                timePerSlotSamples.reduce((sum, cur) => {
                    return sum + cur;
                }, 0) / samplesInHour;

            const hourlySlotTime = Math.round(1000 * avgSlotTime_1h);
            const epochTimeRemaining = (slotsInEpoch - slotIndex) * hourlySlotTime;

            console.log(`epochProgress: ${epochProgress}, epochTimeRemaining: ${epochTimeRemaining}`);
            return {
                epochInfo,
                epochProgress,
                epochTimeRemaining,
            };
        },
        getTokens() {
            console.log('url', 'https://api')
            axios.get('https://token.jup.ag/all').then(res => {
                this.tokens = res.data
                console.log('tokens', this.tokens)
                this.getWalletBalances()
            })
        },
        getToken(mint) {
            if (typeof mint !== 'string') mint = new PublicKey(mint).toBase58()
            return this.tokens.find(t => t.address === mint)
        },
        getWalletBalances() {
            if (!this.wallet.connected) {
                window.setTimeout(() => {
                    this.getWalletBalances()
                }, 3000)

                return
            }

            // console.log('retrieving walletBalances')
            const accounts = connection.getParsedTokenAccountsByOwner(
                this.wallet?.publicKey,
                {programId: new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')}
            ).then(accounts => {
                let balances = {}
                accounts.value.forEach(account => {
                    // console.log('token account',account)
                    const mint = account.account.data.parsed.info.mint
                    // console.log('found mint', mint)
                    const token = this.getToken(mint)
                    if (token) {
                        // console.log(token)
                        balances[mint] = account.account.data.parsed.info.tokenAmount.amount / (10 ** token.decimals)
                    }

                })

                this.balance = balances[this.fromAddress] || 0
                const solanaMint = 'So11111111111111111111111111111111111111112'
                const solanaBalance = connection.getBalance(this.wallet?.publicKey).then((bal) => {
                    balances[solanaMint] = bal / (10 ** 9)
                    // console.log('balance',bal)
                    // console.log('found balances', balances, balances[this.fromAddress])
                    this.balances = balances
                    this.balance = balances['So11111111111111111111111111111111111111112'] || 0
                    this.delegationAmount = this.balance - 0.05
                })

            })
        },
        async getFxRates() {
            let rates = await axios.get('https://api.coingecko.com/api/v3/coins/solana/market_chart?vs_currency=' + this.selectedCurrency + '&days=max&interval=daily')
            let byDay = {}
            rates = rates.data.prices.map((day) => {
                day[0] = new Date(day[0]).toISOString().split('T')[0]
                byDay[day[0]] = day[1]
                return day
            })
            console.log(byDay)
            this.fxRates = byDay; //collect(rates).keyBy(0)
        },
        async getValidators() {
            // window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            let vdata = await axios.get('https://solanacompass.com/validators/ajax', {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            this.validatorData = vdata.data
            // console.log('vdata', this.validatorData)
            let data = await axios.get('/statistics/staking', {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            console.log('validator data', data)
            // this.validatorData = collect(data.data[1]).keyBy('key')
            this.epochs = data.data.epochTrends
            let spdata = await axios.get('https://solanacompass.com/stake-pools', {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            this.stakePools = collect(spdata.data[0]).keyBy('poolMint')
            // this.validatorData = spdata.data[2]
            console.log('stake pools', spdata.data)
            this.validatorToDelegate = this.validatorData['EARNynHRWg6GfyJCmrrizcZxARB3HVzcaasvNa8kBS72']
            this.validatorToDelegateName = this.validatorToDelegate.name
        },
        searchValidators(queryString, cb) {
            const results = queryString ?
                Object.values(this.validatorData).filter((v) => {
                    return (v.name || '' + ' ' + v.vote_account).toLowerCase().includes(queryString.toLowerCase())
                }) : Object.values(this.validatorData).slice(0, 10)
            return results
        },
        selectValidator(val) {
            this.validatorToDelegate = val
            this.validatorToDelegateName = val.name
        },
        getStakeAPY(account) {
            const apys = []
            if (account.rewards.length == 0) return 0
            Object.keys(account.rewards).sort().forEach((i) => {
                //(1 + rewards / (activeStake - rewards)) ** 125 - 1
                let r = account.rewards[i]
                if (r !== null) {
                    let apy = (1 + r.amount / (r.postBalance - r.amount)) ** 125 - 1
                    apys.push(apy)
                }
            })
            return (collect(apys).avg() * 100).toFixed(2)
        },
        getStakeHealth(account) {

            if ((!account.account.data.parsed.info.stake) || (account.account?.data?.parsed?.info?.stake?.delegation?.deactivationEpoch < this.epochInfo.epoch)) {
                return '<div class="badge bg-danger text-white" title="This stake is undelegated and earning no rewards. You should either delegate it to a validator to start earning rewards, or withdraw it to your account.">Undelegated</div>'
            }


            if (account.account.data.parsed.info.stake.delegation.deactivationEpoch == this.epochInfo.epoch) {
                return '<div class="badge bg-warning text-white" title="This stake is deactivating. It will stop earning rewards and become available to withdraw at the end of this epoch">Deactivating</div>'
            }
            if (account.account.data.parsed.info.stake.delegation.activationEpoch == this.epochInfo.epoch) {
                return '<div class="badge bg-info text-white" title="This stake is delegated and activating. It will become active at the end of the current epoch, and earn its first rewards at the end of epoch ' + (this.epochInfo.epoch + 1) + '">Activating</div>'
            }

            // check there isn't wasted, inactive stake on the account. Alert on >0.05 sol only

            let inactive = parseInt(account.account.lamports) - (parseInt(account.account.data.parsed.info.stake.delegation.stake) + parseInt(account.account.data.parsed.info.meta.rentExemptReserve))
            // console.log(inactive, account.account.lamports, (account.account.data.parsed.info.stake.delegation.stake + account.account.data.parsed.info.meta.rentExemptReserve))
            if (inactive > (0.05 * 1e9)) {
                return '<div class="badge bg-warning text-white" title="There are ' + (inactive / 1e9) + ' inactive SOL in this account that is currently earning no staking rewards. To earn rewards, first withdraw the excess SOL and then create + delegate a new stake account.">Missing Rewards</div>'
            }
            let validator = this.validatorData[account.account.data.parsed.info.stake.delegation.voter]

            if (!validator) return '' // maybe don't have validator info yet

            // if (validator.total / 1e9 > 1_000_000) return '<div class="badge bg-warning text-white">High Stake</div>'
            // centralization stuff should go here, maybe other bits too?

            return '<div class="badge bg-success text-white">Good</div>'

        },
        selectMerge(val) {
            console.log(val)
            this.accountsToMerge = val
        },

        canMerge(intoAccount) {
            const mergeable = []
            this.stakeAccounts.forEach((a) => {
                // conditions:
                // skip if deactivating/ed:
                if ((a.account?.data?.parsed?.info?.stake?.delegation?.deactivationEpoch > 0) && (a.account?.data?.parsed?.info?.stake?.delegation?.deactivationEpoch < 10_000_000)) return

                // both deactivated
                if (a.account.data.parsed.type == 'initialized' && intoAccount.account.data.parsed.type == 'initialized') mergeable.push(a)

                // both activating in same epoch to the same validator
                // both activated to same validator.. do we need seperate conditions?
                let aDelegation = a.account.data.parsed?.info?.stake?.delegation;
                let intoDelegation = intoAccount.account.data.parsed?.info?.stake?.delegation;
                if (aDelegation && intoDelegation) {
                    if (aDelegation?.voter == intoDelegation?.voter) {
                        if ((aDelegation?.activationEpoch == intoDelegation?.activationEpoch) && aDelegation.activationEpoch == this.epochInfo.epoch) mergeable.push(a)
                        if ((aDelegation?.activationEpoch < this.epochInfo.epoch) && (intoDelegation?.activationEpoch < this.epochInfo.epoch)) mergeable.push(a)

                        //what is one is active but deactivating? will solana let it work?
                    }
                }
                // inactive account into activating account
                if (intoDelegation) {
                    if (a.account.data.parsed.type == 'initialized' &&
                        intoDelegation?.activationEpoch == this.epochInfo.epoch) mergeable.push(a)
                }
                if (aDelegation) {
                    if (intoAccount.account.data.parsed.type == 'initialized' &&
                        aDelegation?.activationEpoch == this.epochInfo.epoch) mergeable.push(a)

                }
            })
            return mergeable
        },
        canWithdraw(account) {
            if (!account.account.data?.parsed?.info?.stake) return account.account.lamports
            if (account.account?.data?.parsed?.info?.stake?.delegation?.deactivationEpoch < this.epochInfo.epoch) return account.account.lamports

            // otherwise, is there any inactive stake here?
            let inactive = parseInt(account.account.lamports) - (parseInt(account.account.data.parsed.info.stake.delegation.stake) + parseInt(account.account.data.parsed.info.meta.rentExemptReserve))
            return inactive

        },
        async splitStakeAccount(account, lamports) {
            let newAccount = new Keypair()
            const splitStakeInstruction = StakeProgram.split(
                {
                    authorizedPubkey: this.wallet.publicKey,
                    stakePubkey: account.pubkey,
                    lamports: lamports,
                    splitStakePubkey: newAccount.publicKey
                })
            // this.sendTx([splitStakeInstruction])

            return [splitStakeInstruction, newAccount]
        },
        async createStakeAccount(sol) {

            const solToLamport = sol * 1000000000;
            if (this.wallet.publicKey instanceof PublicKey) {
                const isValid = this.balance >= sol;
                // if (isValid) {
                const minimumAmount = await connection.getMinimumBalanceForRentExemption(
                    StakeProgram.space,
                );
                const fromPubkey = this.wallet.publicKey;
                const newStakeAccount = new Keypair();
                const authorizedPubkey = this.wallet.publicKey;
                const authorized = new Authorized(authorizedPubkey, authorizedPubkey);
                const lockup = new Lockup(0, 0, fromPubkey);
                const lamports = minimumAmount + solToLamport;
                const stakeAccountIns = {
                    fromPubkey,
                    stakePubkey: newStakeAccount.publicKey,
                    authorized,
                    lockup,
                    lamports
                }
                console.log(stakeAccountIns)
                const newStakeAccountIns = StakeProgram.createAccount(stakeAccountIns)
                return {newStakeAccountIns, newStakeAccount}

                // } else console.log('insufficent funds')
            } else console.log('no publickey', this.wallet)
        },
        async delegate() {
            if (this.wallet.publicKey instanceof PublicKey) {
                try {

                    await this.createStakeAccount(this.amount).then(r => {

                        const stakeAcc = r?.newStakeAccount;
                        const instruction = {
                            stakePubkey: stakeAcc.publicKey,
                            authorizedPubkey: new PublicKey(this.wallet.publicKey),
                            votePubkey: new PublicKey(this.vote || 'EARNynHRWg6GfyJCmrrizcZxARB3HVzcaasvNa8kBS72')
                        }
                        const stakeAccIns = r?.newStakeAccountIns;
                        const stake = [stakeAccIns, StakeProgram.delegate(instruction)]
                        this.sendTx(stake, [stakeAcc])

                    })
                } catch (error) {
                    // this.$honeybadger.notify(error)
                    console.log(error)
                }
                this.clicky('/dashboard/delegate/' + this.vote + '/' + this.amount)
            }
        }
        ,
        async sendTx(txParam, extraSigners = []) {

            this.loading = true
            var success = false
            try {
                const {blockhash, lastValidBlockHeight} = await connection.getLatestBlockhash();
                let transaction = new Transaction({
                    feePayer: this.wallet.publicKey,
                    recentBlockhash: blockhash,
                    lastValidBlockHeight
                }).add(...txParam);
                console.log(transaction, txParam, extraSigners)
                if (typeof this.wallet.signTransaction !== 'undefined') {
                    console.log('transaction', transaction)
                    transaction = await this.wallet.signTransaction(transaction);
                    // //LMT: add extra signers (fix create-token-account problem)
                    if (extraSigners.length > 0) transaction.partialSign(...extraSigners);
                    // //LMT: check null signatures
                    for (let i = 0; i < transaction.signatures.length; i++) {
                        if (!transaction.signatures[i].signature) {
                            throw Error(`missing signature for ${transaction.signatures[i].publicKey.toString()}. Check .isSigner=true in tx accounts`)
                        }
                    }
                    //
                    console.log('serializing')
                    const rawTransaction = transaction.serialize({requireAllSignatures: false});
                    console.log('sending raw')
                    const txid = await connection.sendRawTransaction(rawTransaction);
                    // const txid = await this.wallet.sendTransaction(transaction,connection, {signers: extraSigners})
                    // const txid = await this.wallet.sendTransaction(transaction)
                    console.log('transaction id', txid)
                    /* this.toast(`transaction: ${txid}`, 'info', () => {
                       window.open(`https://explorer.solana.com/tx/${txid}?cluster=${process.env.REACT_APP_NETWORK}`)
                     })*/
                    const result = await connection.confirmTransaction(txid, 'confirmed');
                    console.log('confirmed transaction?', result)
                    // this.toast('Stake Account Created', 'success')
                    success = true

                }
            } catch (error) {
                console.log(error)
                // this.toast('Failed to configure stake account', 'error')
                this.toast(error, 'error')
                // this.$honeybadger.notify(error)
                success = false
            }
            this.loading = false
            return success
        },
        toast(msg, type) {
            ElMessage({
                type: type,
                message: msg
            })

        },
        async delegateStake() {
            let instructions = []
            var pubkey = ''
            var account = {}
            var signers = []
            if (!this.activeStakeAccount) {
                let r = await this.createStakeAccount(this.delegationAmount)
                pubkey = r.newStakeAccount.publicKey
                account = r.newStakeAccount
                console.log('created stake account', r.newStakeAccount, pubkey)
                signers = [account]
                instructions.push(r.newStakeAccountIns)
            } else {
                pubkey = this.activeStakeAccount.pubkey
                account = this.activeStakeAccount
            }
            // local '8UGmb94eR39GLPkwqm3DmDhzZRechFbVxB2pcyt7D2KJ') //'EARNynHRWg6GfyJCmrrizcZxARB3HVzcaasvNa8kBS72')
            // override if we don't have a validator list for local..
            let votePubkey = ''
            if (localhost) votePubkey = new PublicKey('EdEaychcN9i89RGABc6R1VJTMFH8BWcu2ErBFdbyRVSQ')
            else votePubkey = new PublicKey(this.validatorToDelegate.vote_account)
            const instruction = {
                stakePubkey: pubkey,
                authorizedPubkey: this.wallet.publicKey,
                votePubkey: votePubkey
            }
            instructions.push(StakeProgram.delegate(instruction))
            console.log('delegate instructions', instruction, instructions, pubkey)
            let success = await this.sendTx(instructions, signers)
            console.log(success)
            if (success) {
                this.toast('Successfully delegated stake', 'success')
                if (this.activeStakeAccount) this.clicky('/dashboard/delegate/' + votePubkey + '/' + (this.activeStakeAccount.account.lamports / 1e9))
                else this.clicky('/dashboard/delegate/' + votePubkey.toString() + '/' + this.delegationAmount)
                if (typeof clicky === 'object') {
                    // eslint-disable-next-line
                    clicky.goal('Delegated Stake', this.delegationAmount)
                }
                axios.post('/log/stake', {
                    txid: 'txid',
                    staker: this.wallet.publicKey,
                    amount: this.delegationAmount * 1e9,

                    wallet: this.wallet.wallet.adapter.name,
                    stake_to: this.voteKey
                })
            }
            this.showDelegate = false
            this.getStakeAccounts()
            this.getWalletBalances()


        },
        updateWithdrawalAmountSol() {
            this.withdrawAmountSol = (this.activeStakeAccount.account.lamports / 1e9) * (this.withdrawAmount / 100)
        },
        updateWithdrawAmount() {
            this.withdrawAmount = ((this.withdrawAmountSol * 1e9) / this.activeStakeAccount.account.lamports) * 100
        },
        async deactivateStake() {
            let instructions = []
            let account = this.activeStakeAccount
            // account.publicKey = account.pubkey

            let signers = []
            let deactivatePubkey = account.pubkey
            if (this.withdrawAmount != 100) {
                let split = await this.splitStakeAccount(this.activeStakeAccount, this.withdrawAmountSol * 1e9)
                console.log(split)
                instructions.push(split[0])
                let newAccount = split[1]
                deactivatePubkey = newAccount.publicKey
                signers = [newAccount]
            }

            let params = {
                stakePubkey: deactivatePubkey,
                authorizedPubkey: new PublicKey(this.wallet.publicKey)
            };
            console.log('deactivate params', params, account)
            instructions.push(
                StakeProgram.deactivate(params)
            )
            console.log('sending instructions', instructions)
            let success = await this.sendTx(instructions, signers)
            if (success) this.toast('Successfully deactivated stake', 'success')
            this.getStakeAccounts()
            this.clicky('/dashboard/deactivate')
            this.showDeactivate = false
        },
        async withdrawStake(account) {
            // either the entire inactive balance, or any transferred, inactive sol
            console.log(account)
            let lamports = this.canWithdraw(account)
            let instructions = [
                StakeProgram.withdraw({
                    stakePubkey: account.pubkey,
                    authorizedPubkey: this.wallet.publicKey,
                    toPubkey: this.wallet.publicKey,
                    lamports: lamports
                })
            ]
            let success = await this.sendTx(instructions)
            console.log(success) // undef on success
            if (success) this.toast('Successfully withdrew stake from account', 'success')
            this.clicky('/dashboard/withdraw')
            this.getStakeAccounts()
            this.getWalletBalances()
            // this.toast('Withdre')

        },
        async splitStake() {
            let r = await this.splitStakeAccount(this.activeStakeAccount, this.splitStakeAmount * 1e9)
            console.log(r)
            let result = await this.sendTx([r[0]], [r[1]])
            if (result) this.toast('Successfully split stake account', 'success')
            this.showSplit = false
            this.clicky('/dashboard/split')
            this.getStakeAccounts()
        },
        async mergeStake(otherAccounts) {
            let instructions = []
            let account = otherAccounts.shift()
            otherAccounts.forEach((a) => {

                let ins = {
                    stakePubkey: account.pubkey,
                    sourceStakePubKey: a.pubkey,
                    authorizedPubkey: this.wallet.publicKey
                };
                console.log('merging', account.pubkey.toString(), a.pubkey.toString(), this.wallet.publicKey.toString(), ins)
                instructions.push(StakeProgram.merge(ins))
                // a.publicKey = a.pubkey
                // return a
            })
            let signers = [] // otherAccounts
            console.log(signers)
            signers.push[account]
            console.log('sending tx', instructions, signers)
            let result = await this.sendTx(instructions, signers)
            if (result) this.toast('Successfully merged stake accounts', 'success')
            this.showMerge = false
            this.clicky('/dashboard/merge')
            this.getStakeAccounts()

        },
        downloadCSVData() {
            var csv = Object.keys(this.fiatReturns[0]).join(',') + "\n"
            this.fiatReturns.forEach((row) => {
                csv += Object.values(row).join(',') + "\n"
            })

            const anchor = document.createElement('a')
            anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
            anchor.target = '_blank';
            anchor.download = 'stakingReturns.csv';
            anchor.click();
            this.clicky('/dashboard/exportcsv')
        }

    }
}
</script>


<style>
::v-deep .modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;
}

.modal__title {
    margin: 0 2rem 0 0;
    font-size: 1.5rem;
    font-weight: 700;
}

.modal__close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
}
.dark-mode div::v-deep .modal-content {
    border-color: #2d3748;
    background-color: #1a202c;
}

.el-input-number--large, .el-autocomplete {
    width: 100%;

}

.el-slider__marks-text {
    margin-top: 5px;
    width: 32px;
}
.el-slider__marks-text {
    width: 32px;
    font-size: 12px !important;
}

.el-form-item__label {
    font-weight: 600;
}

.text-left {
    text-align: left;
}

.el-popover.el-popper {
    text-align: left !important;
    word-break: break-word !important;
    font-size: 90% !important;
}
.el-table__header th {
    font-size: 85%;
}
</style>
